import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
`;

export const PContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 1rem;

  p {
    font-size: 20px;
    text-align: justify;
    line-height: 1.5;
  }

  span {
    background-color: #FFFEEB;
    padding: 0.2rem;
    border-radius: 2px;
    color: #10254D;
  }

  @media (min-width: 1024px) {
    width: 50%;
  }
`;

export const ProgressBarContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.2rem;
`;
